import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { PartnersTableDefinitionZod } from '../tables';

type Arguments = Record<string, never>;

export const schemaPartnerResolver_GetPotentialLeadSourcePartners = z.array(PartnersTableDefinitionZod);

export type SchemaPartnerResolver_GetPotentialLeadSourcePartners = z.infer<
    typeof schemaPartnerResolver_GetPotentialLeadSourcePartners
>;
export type PartnerResolver_GetPotentialLeadSourcePartners = Resolver<
    Arguments,
    SchemaPartnerResolver_GetPotentialLeadSourcePartners
>;
